export const environment = {
  apis: {
    audius: {
      clientId: '7fbde568a2c420c60696481ed174fc3f8b816893',
      clientSecret: '022b4597b97971b6f2f17398227802b4fef7d7705674ec3f29900c1d536c4caa'
    },
    spotify: {
      clientId: '0a1e3b2cba2a474098e259b2526fa484',
      clientSecret: 'eb64f20c2c1c495682d9ba721b6d076a',
    },
    countryStateCity: {
      key: 'Smh5aTVid29mc0FJcDZiWU5zeGVSeHhSdXNIZFUwMDFRZ2pweTZpUQ==',
    },
  },
  url: 'https://spotify-luishidalgoa.vercel.app',
};
